import { Component, OnInit, Output, ViewChildren, QueryList } from '@angular/core';
import { Observable } from 'rxjs';
import { CommonConstants } from './../common/utilities/commonConstants';
import { RouteContextProvider } from './../common/services/routeContextProvider.service';
import { RouteHandlerService } from './../common/services/routeHandler.service';
import { Formatter } from './../common/services/formatter';
import { ConfigService } from './../common/services/config.service';
import { CookieHandlerService } from './../common/services/cookieHandler.service';
import { HomeService } from './../home/home.service';
import { SharedService } from './../common/services/sharedService';
import { AnalyticsService } from './../common/services/device.analytics.service';
import { HttpInterceptor } from './../common/services/httpInterceptor.service';
import { SessionHandlerService } from '../common/services/sessionHandler.service';
import { PopupComponent } from '../common/utilities/popup/popup.component';
import { Router } from '@angular/router';
import { HttpHeaders } from '@angular/common/http';
const generateOtpObj = {
    mobile: 0,
    policyName: 'PL',
    mfa: true
};
@Component({
    selector: 'app-customer-login',
    templateUrl: './customerLogin.template.html',
    styleUrls: ['./customerLogin.style.css']
})
export class CustomerLoginComponent implements OnInit {
    @Output() public ResumeApplObj;
    private readonly CUSTOMER: string = 'customer';
    public MainLoadingText = 'Stay with us. We\'re almost done...';
    public showLoader = false;
    private _viewType: string;
    private partnerKey: string;
    public nextTaskKey: string;
    startResumeData: Observable<ActivitiModel.MTResponse<any>>;
    EnableResumeOTPPage: boolean;
    public snatchSession = null;
    overrideCustomerSession;
    @ViewChildren(PopupComponent) public PopupComponent: QueryList<any>;
    ContentPopup: { Id: string; Title: string; Config: CustomModalOptions; };
    public Config = { show: false, backdrop: 'static' };
    mobileNumber;
    bflJourney: any;
    isMobileJourney = false;
    productCode: string;

    constructor(
        private _routeContextProvider: RouteContextProvider,
        private _routerService: RouteHandlerService,
        private _homeService: HomeService,
        private _sharedService: SharedService,
        private _cookieHandler: CookieHandlerService,
        private _analyticsService: AnalyticsService,
        private _formatter: Formatter,
        private _httpInterceptor: HttpInterceptor,
        private _sessionStorage: SessionHandlerService,
        private _sessionHandlerService: SessionHandlerService,
        public _router: Router,
    ) {
        // constructor
    }
    public ngOnInit() {
        this.bflJourney = this._sharedService.isBFLJourney();
        this.productCode = CommonConstants.LOAN_PRODUCT_CODES.Health_Insurance;

        const isMobile = this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.IsMobile) || this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.isMobile);
        this.isMobileJourney = (isMobile && isMobile === '1') ? true : false;
        const appID = this._routeContextProvider.GetQueryParams('application_id');
        if (window.name !== appID) {
            if (window.name.length) {
                this._cookieHandler.DeleteCookies([CommonConstants.CookieKeys.applicationId], window.name);
            }
            const cookieAppID = this._cookieHandler.GetCookie(CommonConstants.CookieKeys.applicationId, appID);
            if (((appID === cookieAppID) && appID && cookieAppID) && !this._analyticsService.GetDeviceDetails().mobile) {
                this._routerService.RouteToNextTask('multitabfailed');
                return;
            }
        }
        this._cookieHandler.DeleteCookies(['SS_1_APP_PRO_ID']);
        this._viewType = this._routeContextProvider.GetRouteParams('CustomerType');
        this.partnerKey = this._routeContextProvider.GetQueryParams('partnerKey');
        this._sharedService.setData(CommonConstants.QueryParamsKeys.Productcode,
            CommonConstants.LOAN_PRODUCT_CODES.HealthCombo_Insurance);
        const InsProductType = this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.InsProductType);
        if (InsProductType) {
            this._sessionStorage.SetSession(CommonConstants.CookieKeys.InsProductType, InsProductType);
        }
        this.opreationsOnInit();
        this.setUtmParams();
        this.fetchQueryParams();
    }
    private fetchQueryParams() {
        const _mobileNumber = this._routeContextProvider.GetQueryParams('m');
        if (this.partnerKey) {
            generateOtpObj.mobile = parseInt(_mobileNumber, 10);
        }
        const DOB = this._routeContextProvider.GetQueryParams('d');
        const OTP = this._routeContextProvider.GetQueryParams('o');
        if (_mobileNumber && DOB) {
            const _tempObj = {};
            _tempObj['mobileNumber'] = _mobileNumber;
            _tempObj['DOB'] = DOB;
            _tempObj['OTP'] = (OTP) ? OTP : null;
            this.ResumeApplObj = _tempObj;
            this._cookieHandler.SetCookie(CommonConstants.CookieKeys.EmployeeResume,
                CommonConstants.DEFAULT_EMPTY_STRING);
        }
    }
    private opreationsOnInit() {
        this._cookieHandler.DeleteCookies([CommonConstants.SharedServiceDataKeys.JourneySource]);
        this.authenticateSystem();
    }
    private authenticateSystem(): void {
        const sessionValue = this._routeContextProvider.GetQueryParams('sessionId');
        const epToken = this._cookieHandler.GetCookie(CommonConstants.CookieKeys.JWTokenEP);
        const sourceType = this._routeContextProvider.GetQueryParams('sourceType');
        if (sessionValue && epToken) {
            this._sessionStorage.SetSession(CommonConstants.CookieKeys.JWToken, epToken);
            this._sessionStorage.SetSession(CommonConstants.CookieKeys.GuardKey, this._cookieHandler.GetCookie(CommonConstants.CookieKeys.GuardKeyEP));
            this._sessionStorage.SetSession(CommonConstants.CookieKeys.GuardToken, this._formatter
                .ConvertGuradKeyToGuardToken(this._cookieHandler.GetCookie(CommonConstants.CookieKeys.GuardTokenEP)));
        }
        this.setSystemAuthToken(CommonConstants.LOAN_PRODUCT_CODES.Health_Insurance);
    }

    private setEpTokens(response) {
        if (response.headers) {
            const authToken = response.headers.get('authtoken');
            if (authToken !== null && authToken !== '') {
                this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.JWToken, authToken);
            }
        }
    }
    private setSystemAuthToken(productCode: string): void {
        this._homeService.GetResumeAuthToken({
            productCode
        }).subscribe((responseData: ActivitiModel.MTResponse<any>) => {
            if (!responseData.errorBean) {
                this.snatchSession = null;
                const tokenObj = responseData.payload.tokens[0];
                console.log('tokens::', tokenObj);
                const epToken = this._cookieHandler.GetCookie(CommonConstants.CookieKeys.JWTokenEP);
                if (!epToken) //!sessionValue && 
                {
                    this._sessionStorage.SetSession(CommonConstants.CookieKeys.JWToken, tokenObj.token);
                    this._sessionStorage.SetSession(CommonConstants.CookieKeys.GuardKey, tokenObj.guardKey);
                    this._sessionStorage.SetSession(CommonConstants.CookieKeys.GuardToken, this._formatter
                        .ConvertGuradKeyToGuardToken(tokenObj.guardKey));
                }
                this.initProcess(response => {
                    if ((!response.errors || !response[0].errorCode) && response.payload && response.nextTask) {
                        this.setresponseValues(response);
                        this.setEpTokens(response);
                        const appId = response.payload.applicationId;
                        const appIdFromCookie = + this._cookieHandler.GetCookie(CommonConstants.CookieKeys.LoanApplicationId);
                        console.log(response);
                        if (appIdFromCookie === undefined || appIdFromCookie === 0) {
                            this._cookieHandler.SetCookie(CommonConstants.CookieKeys.LoanApplicationId, appId);
                        } else if (((appId === appIdFromCookie) && appId && appIdFromCookie)
                            && !this._analyticsService.GetDeviceDetails().mobile) {
                            this._routerService.RouteToNextTask('multitabfailed');
                            return;
                        }
                        if (response.nextTask.nextTaskKey === 'otpTokenPage') {
                            this.mobileNumber = response.payload.mobile;
                            this.EnableResumeOTPPage = true;
                        } else {
                            this._routerService.RouteToNextTask(response.nextTask.nextTaskKey);
                        }
                    }
                    else if (response[0].errorCode === 'OMIB-0016') {
                        this.snatchSession = "Customer session is in progress. Do you still want to continue?";
                        this.ShowChildModal('sessionupdate');
                    }
                    else if (Array.isArray(response) && !response[0].errorCode || !response[0].errorMessage) {
                        console.log('Error Occured on Resume Application:: ', response[0].errorMessage);
                    }
                    else {
                        console.log('Error Occured on Resume Application.');
                    }
                    this.showLoader = false;
                });
            }
        });
    }
    private setresponseValues(mtResponse) {
        this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.applicationId,
            mtResponse.payload.applicationId);
        this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.processId,
            mtResponse.nextTask.processId);
        let quoteId = (mtResponse.payload.quoteId === null) ? 0 : mtResponse.payload.quoteId;
        this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.quoteId, quoteId);
        this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.selectedQuoteId, quoteId);
        this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.NextTaskKeyOmHR, mtResponse.nextTask.nextTaskKey);
        this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.SelfDob,
            mtResponse.payload.dateOfBirth);
        this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.SelfGender,
            mtResponse.payload.proposerGender);
        const quoteCriteriaData = {
            appQuoteCriteriaId: mtResponse.payload.appQuoteCriteriaId,
            applicationId: mtResponse.payload.applicationId,
            mobile: null,
            quoteCriteria: {
                hGIQuoteCriteria: null
            },
            quoteIds: mtResponse.payload.quoteIds,
        }
        this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.planQuoteCriteriaData,
            JSON.stringify(quoteCriteriaData));
    }
    private initProcess(callback: Function) {
        this.showLoader = true;
        let url = ConfigService.getInstance().getConfigObject().APIURL.ResumeLandingGetCall;
        url = url + '?journeytypeflag=' + this._routeContextProvider.GetQueryParams('journeytypeflag');
        if (this.snatchSession) {
            url = url + '&overrideCustomerSession=' + this.overrideCustomerSession;
        }
        const sessionValue = this._routeContextProvider.GetQueryParams('sessionId');
        if (sessionValue) {
            url = url.replace('{sessionId}', sessionValue);
        } else {
            url = url.replace('{sessionId}', 0);
        }
        url = url.replace('{prodCatCode}', 'HGI');
        let headerObj: HttpHeaders;
        headerObj = new HttpHeaders({});
        this.startResumeData = this._httpInterceptor.applicationTokensPost(url, {}, headerObj, true);
        this.startResumeData.subscribe(resp => {
            callback(resp);
        });
    }

    private checkUtmSources(utmObj) {
        if (Object.keys(utmObj).length !== 0) {
            return utmObj;
        } else {
            return false;
        }
    }
    private CheckUtmMediumForDevice(value: string) {
        const deviceDetails: DeviceDetails = this._analyticsService.GetDeviceDetails();
        if (deviceDetails.mobile) {
            value = value.concat('_mobile');
        }
        return value;
    }
    private setUtmParams() {
        const src_90 = this._routeContextProvider.GetQueryParams('src_90');
        const src_60 = this._routeContextProvider.GetQueryParams('src_60');
        const src_30 = this._routeContextProvider.GetQueryParams('src_30');
        const pid = this._routeContextProvider.GetQueryParams('pid');
        const source = this._routeContextProvider.GetQueryParams('utm_source');
        const medium = this._routeContextProvider.GetQueryParams('utm_medium');
        const campaign = this._routeContextProvider.GetQueryParams('utm_campaign');
        const content = this._routeContextProvider.GetQueryParams('utm_content');
        const term = this._routeContextProvider.GetQueryParams('utm_term');
        const utmType = src_90 ? 'src_90' : src_60 ? 'src_60' : src_30 ? 'src_30' : pid ? 'pid' : 'utm';
        let utm = '';
        if ((source || medium || campaign || content || term) && utmType === 'utm') {
            utm = ['', source, medium, campaign, content, term].join(':');
        }
        console.log('source', source, 'medium', medium);

        this._sessionHandlerService.SetSession('UTM', src_90 || src_60 || src_30 || pid || utm);
        this._sessionHandlerService.SetSession('UtmType', utmType);
        this._sharedService.setData('UTM', src_90 || src_60 || src_30 || pid || utm);
        this._sharedService.setData('UtmType', utmType);
    }
    public proceedNext(value) {
        this.overrideCustomerSession = value;
        this.HideChildModal('sessionupdate');
        this.initProcess(response => {
            if (!response.errors && response.payload && response.nextTask) {
                this.setresponseValues(response);
                this.setEpTokens(response);
                console.log(response)
                const appId = response.payload.applicationId;
                const appIdFromCookie = + this._cookieHandler.GetCookie(CommonConstants.CookieKeys.LoanApplicationId);
                if (appIdFromCookie === undefined || appIdFromCookie === 0) {
                    this._cookieHandler.SetCookie(CommonConstants.CookieKeys.LoanApplicationId, appId);
                } else if (((appId === appIdFromCookie) && appId && appIdFromCookie)
                    && !this._analyticsService.GetDeviceDetails().mobile) {
                    this._routerService.RouteToNextTask('multitabfailed');
                    return;
                }
                if (response.nextTask.nextTaskKey === 'otpTokenPage') {
                    this.mobileNumber = response.payload.mobile;
                    this.EnableResumeOTPPage = true;
                } else {
                    this._routerService.RouteToNextTask(response.nextTask.nextTaskKey);
                }
            } else if (Array.isArray(response) && !response[0].errorCode || !response[0].errorMessage) {
                console.log('Error Occured on Resume Application:: ', response[0].errorMessage);
            }
            else {
                console.log('Error Occured on Resume Application.');
            }
            this.showLoader = false;
        });
    }
    private initContentPopup() {
        this.ContentPopup = {
            Id: 'content-modal',
            Title: 'Riders',
            Config: <CustomModalOptions>{ show: false, closeOption: true }
        };
    }
    private getModalDirectiveInstanceBasedOnId(popupId: string): any {
        console.log(this.PopupComponent);
        return this.PopupComponent.filter((item: PopupComponent) => {
            return item.id === popupId;
        })[0].modalControl;
    }
    public ShowChildModal(id: string, contentType?: string): void {
        if (contentType) {
            this.initContentPopup();
        }
        this.getModalDirectiveInstanceBasedOnId(id).show();
    }
    public HideChildModal(id: string): void {
        this.getModalDirectiveInstanceBasedOnId(id).hide();
    }
}
